<section class="labor-profile" aria-labelledby="labor-profile-title">
  <header class="labor-profile__header">
    <h2 id="labor-profile-title" mat-dialog-title>{{'record_management_moha.employment_dossier_detail' | translate}}</h2>
    <button mat-icon-button type="button" aria-label="Đóng" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-divider></mat-divider>

  <div class="labor-profile__worker">
    <div class="worker-summary">
      <div class="worker-avatar" aria-hidden="true">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.2902 2.36861C15.2902 2.36861 16.0621 2.04401 17.606 1.3948C19.1499 0.745586 21.6146 0.420982 25 0.420982C28.3854 0.420982 31.622 1.07019 34.7098 2.36861C37.7976 3.66703 40.4576 5.41351 42.6897 7.60802C44.9219 9.80254 46.6983 12.4177 48.019 15.4534C49.3397 18.4892 50 21.6712 50 24.9996C50 28.3096 49.3443 31.4825 48.0329 34.5183C46.7215 37.554 44.9498 40.1691 42.7176 42.3637C40.4855 44.5582 37.8255 46.3092 34.7377 47.6168C31.6499 48.9243 28.404 49.5781 25 49.5781C21.596 49.5781 18.3501 48.9289 15.2623 47.6305C12.1745 46.3321 9.51916 44.581 7.29632 42.3774C5.07347 40.1737 3.30171 37.5586 1.98103 34.532C0.660342 31.5054 0 28.3279 0 24.9996C0 21.6712 0.660342 18.4892 1.98103 15.4534C3.30171 12.4177 5.07812 9.80254 7.31027 7.60802C9.54241 5.41351 12.2024 3.66703 15.2902 2.36861ZM42.2712 37.4809C45.0428 33.7319 46.4286 29.5715 46.4286 24.9996C46.4286 22.1467 45.8612 19.4218 44.7266 16.825C43.5919 14.2281 42.0666 11.9879 40.1507 10.1043C38.2347 8.22065 35.9561 6.72107 33.3147 5.60553C30.6734 4.48998 27.9018 3.93221 25 3.93221C22.0982 3.93221 19.3266 4.48998 16.6853 5.60553C14.0439 6.72107 11.7653 8.22065 9.84933 10.1043C7.93341 11.9879 6.40811 14.2281 5.27344 16.825C4.13876 19.4218 3.57143 22.1467 3.57143 24.9996C3.57143 29.5715 4.95722 33.7319 7.72879 37.4809C8.95647 31.5008 11.8025 28.5108 16.2667 28.5108C18.7035 30.8516 21.6146 32.022 25 32.022C28.3854 32.022 31.2965 30.8516 33.7333 28.5108C38.1975 28.5108 41.0435 31.5008 42.2712 37.4809ZM32.5753 27.1804C32.5753 27.1804 33.0985 26.666 34.1448 25.6373C35.1911 24.6087 35.7143 22.6404 35.7143 19.7327C35.7143 16.825 34.668 14.3424 32.5753 12.2851C30.4827 10.2277 27.9576 9.19904 25 9.19904C22.0424 9.19904 19.5173 10.2277 17.4247 12.2851C15.332 14.3424 14.2857 16.825 14.2857 19.7327C14.2857 22.6404 15.332 25.123 17.4247 27.1804C19.5173 29.2377 22.0424 30.2664 25 30.2664C27.9576 30.2664 30.4827 29.2377 32.5753 27.1804Z" fill="white"/>
        </svg>
      </div>
      <div class="worker-copy">
        <strong>{{ profile.worker.name }}</strong>
        <span>CCCD: {{ profile.worker.certificateNo }}</span>
      </div>
    </div>

    <!-- <button
      mat-raised-button
      color="primary"
      type="button"
      class="send-all-button"
      (click)="requestAction('send-all')"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4976 13.5002L20.9976 3.00017M10.6251 13.8282L13.2533 20.5862C13.4848 21.1816 13.6005 21.4793 13.7673 21.5662C13.9119 21.6415 14.0842 21.6416 14.2289 21.5664C14.3958 21.4797 14.5119 21.1822 14.7441 20.5871L21.3345 3.69937C21.5441 3.16219 21.6489 2.8936 21.5916 2.72197C21.5418 2.57292 21.4248 2.45596 21.2758 2.40616C21.1041 2.34883 20.8356 2.45364 20.2984 2.66327L3.41062 9.25361C2.81555 9.48584 2.51801 9.60195 2.4313 9.76886C2.35614 9.91354 2.35624 10.0858 2.43158 10.2304C2.51848 10.3972 2.81615 10.513 3.4115 10.7445L10.1695 13.3726C10.2904 13.4196 10.3508 13.4431 10.4017 13.4794C10.4468 13.5115 10.4862 13.551 10.5184 13.5961C10.5547 13.647 10.5782 13.7074 10.6251 13.8282Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>
        {{'record_management_moha.upload_all_dossiers_to_moha' | translate}}
      </span>
    </button> -->
  </div>

  <div mat-dialog-content class="labor-profile__content">
    <div class="empty-state" *ngIf="!profile.contracts || profile.contracts.length === 0">
      {{'record_management_moha.no_employment_contract' | translate}}
    </div>

    <article
      class="contract-tree contract-group"
      *ngFor="let contract of profile.contracts; trackBy: trackContract"
    >
      <div class="contract-card">
        <div class="contract-card__topline">
          <span class="ministry-id">
            {{'record_management_moha.moha_id' | translate}} {{ contract.mohaUuid }}
          </span>
          <div class="contract-controls">
            <ng-container [ngSwitch]="contract.status">

              <nz-tag
                *ngSwitchCase="'pending'"
                style="margin-right: 0px;">
                {{ getStatusLabel(contract.status, contract.statusLabel) }}
              </nz-tag>
            
              <nz-tag
                *ngSwitchCase="'processing'"
                nzColor="blue"
                style="margin-right: 0px;">
                {{ getStatusLabel(contract.status, contract.statusLabel) }}
              </nz-tag>
            
              <nz-tag
                *ngSwitchCase="'failed'"
                nzColor="red"
                style="margin-right: 0px;">
                {{ getStatusLabel(contract.status, contract.statusLabel) }}
              </nz-tag>
            
              <nz-tag
                *ngSwitchCase="'completed'"
                nzColor="green"
                style="margin-right: 0px;">
                {{ getStatusLabel(contract.status, contract.statusLabel) }}
              </nz-tag>
            
            </ng-container>
            <button
              *ngIf="hasAppendices(contract)"
              mat-icon-button
              type="button"
              class="collapse-button"
              [attr.aria-expanded]="isContractExpanded(contract)"
              [attr.aria-label]="isContractExpanded(contract) ? 'Thu gọn phụ lục' : 'Mở rộng phụ lục'"
              (click)="toggleContract(contract)"
            >
              <mat-icon>{{ isContractExpanded(contract) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="contract-card__body">
          <div class="document-copy">
            <h3>{{ contract.name }}</h3>
            <span>{{'record_management_moha.document_code' | translate}} {{ contract.documentCode }}</span>
            <span>{{'record_management_moha.contract_validity_period' | translate}} {{ contract.duration }}</span>
          </div>
          <div class="ministry-badge" *ngIf="contract.ministryBadge" aria-label="Dấu Bộ Nội vụ">
            {{ contract.ministryBadge }}
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="contract-card__actions">
          <div class="document-actions">
            <button mat-button type="button" (click)="viewDetail(contract)">
              <svg style="margin-right: 6px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.01677 10.5956C1.90328 10.4159 1.84654 10.3261 1.81477 10.1875C1.79091 10.0834 1.79091 9.91922 1.81477 9.81512C1.84654 9.67654 1.90328 9.58669 2.01677 9.40699C2.95461 7.922 5.74617 4.16797 10.0003 4.16797C14.2545 4.16797 17.0461 7.922 17.9839 9.40699C18.0974 9.58669 18.1541 9.67654 18.1859 9.81512C18.2098 9.91922 18.2098 10.0834 18.1859 10.1875C18.1541 10.3261 18.0974 10.4159 17.9839 10.5956C17.0461 12.0806 14.2545 15.8346 10.0003 15.8346C5.74617 15.8346 2.95461 12.0806 2.01677 10.5956Z" stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.0003 12.5013C11.381 12.5013 12.5003 11.382 12.5003 10.0013C12.5003 8.62059 11.381 7.5013 10.0003 7.5013C8.61962 7.5013 7.50034 8.62059 7.50034 10.0013C7.50034 11.382 8.61962 12.5013 10.0003 12.5013Z" stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{'record_management_moha.view' | translate}}
            </button>
            <button mat-button type="button" (click)="downloadContract(contract)">
              <svg style="margin-right: 6px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M5.83333 8.33333L10 12.5L14.1667 8.33333M10 12.5V2.5" stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{'record_management_moha.download' | translate}}
            </button>
            <!-- <button mat-button type="button" (click)="requestAction('send-contract', contract)">
              <svg style="margin-right: 6px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75182 10.0003H4.16849M4.09794 10.2432L2.15217 16.0555C1.99931 16.5121 1.92288 16.7404 1.97773 16.881C2.02536 17.0031 2.12767 17.0957 2.2539 17.1309C2.39927 17.1715 2.61882 17.0727 3.05793 16.8751L16.9842 10.6083C17.4128 10.4154 17.6271 10.319 17.6933 10.185C17.7508 10.0686 17.7508 9.93203 17.6933 9.81564C17.6271 9.68168 17.4128 9.58524 16.9842 9.39237L3.05308 3.12342C2.61529 2.92641 2.3964 2.82791 2.25118 2.86832C2.12506 2.90341 2.02277 2.99573 1.97497 3.1176C1.91993 3.25793 1.99555 3.48574 2.14678 3.94137L4.09848 9.82159C4.12446 9.89984 4.13744 9.93897 4.14257 9.97899C4.14712 10.0145 4.14707 10.0504 4.14243 10.0859C4.1372 10.1259 4.12412 10.165 4.09794 10.2432Z" stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{'record_management_moha.upload_to_moha' | translate}}
            </button> -->
          </div>

          <button
            mat-stroked-button
            color="primary"
            type="button"
            class="link-appendix-button"
            (click)="assignAppendix(contract)"
          >
            <mat-icon>add</mat-icon>
            {{'record_management_moha.attach_unlinked_appendix' | translate}}
          </button>
        </div>
      </div>

      <section
        class="appendix-section"
        *ngIf="hasAppendices(contract) && isContractExpanded(contract)"
      >
        <span class="appendix-rail" aria-hidden="true"></span>
        <div class="appendix-list">
          <article
            class="appendix-card"
            *ngFor="let appendix of contract.appendices; trackBy: trackAppendix"
          >
            <span class="appendix-connector" aria-hidden="true"></span>

            <div class="appendix-card__topline">
              <ng-container [ngSwitch]="appendix.status">

                <nz-tag
                  *ngSwitchCase="'pending'"
                  style="margin-right: 0px;">
                  {{ getStatusLabel(appendix.status, appendix.statusLabel) }}
                </nz-tag>
              
                <nz-tag
                  *ngSwitchCase="'processing'"
                  nzColor="blue"
                  style="margin-right: 0px;">
                  {{ getStatusLabel(appendix.status, appendix.statusLabel) }}
                </nz-tag>
              
                <nz-tag
                  *ngSwitchCase="'failed'"
                  nzColor="red"
                  style="margin-right: 0px;">
                  {{ getStatusLabel(appendix.status, appendix.statusLabel) }}
                </nz-tag>
              
                <nz-tag
                  *ngSwitchCase="'completed'"
                  nzColor="green"
                  style="margin-right: 0px;">
                  {{ getStatusLabel(appendix.status, appendix.statusLabel) }}
                </nz-tag>
              
              </ng-container>
              <button
                *ngIf="appendix.isCheckStandardized"
                mat-button
                type="button"
                (click)="deleteAppendix(contract,appendix)"
                matTooltip="{{ 'record_management_moha.unlink_appendix' | translate }}"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167" stroke="#4C515B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>

            <div class="document-copy">
              <h3>{{ appendix.name }}</h3>
              <span>{{'record_management_moha.document_code' | translate}} {{ appendix.documentCode }}</span>
              <span>{{'record_management_moha.signing_date' | translate}} {{ appendix.updatedTime }}</span>
            </div>

            <mat-divider></mat-divider>

            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="view-appendix-button"
              (click)="viewDetail(contract, appendix)"
            >
              <mat-icon>visibility</mat-icon>
              {{'record_management_moha.view_detail' | translate}}
            </button>
          </article>
        </div>
      </section>
    </article>
  </div>
</section>
